/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react'
import Skeleton from 'react-loading-skeleton'
import { SelectButtonWrapper } from '.'
import { AVAILABILITY_STATUS, AVAILABILITY_BG_COLOR } from 'utils'

import FilterRadioGroup from './FilterRadioGroup'
import FloorItem from './FloorItem'
import { SelectMultiple } from 'components'
import {
  subscribeToChannel,
  unsubscribeToChannel,
  bindChannel,
  unbindChannel
} from 'services/pusher'
import useRealtimeUnitUpdate from 'hooks/useRealtimeUnitUpdate'
import { useSelector } from 'react-redux'

const groupBy = (list, keyGetter) => {
  const map = new Map()
  list.forEach((item) => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })
  return map
}

const filterOptions = [
  {
    value: AVAILABILITY_STATUS.open,
    bgColor: AVAILABILITY_BG_COLOR.available
  },
  {
    value: AVAILABILITY_STATUS.reservedBroker,
    bgColor: AVAILABILITY_BG_COLOR.reserved
  },
  {
    value: AVAILABILITY_STATUS.soldCommitted,
    bgColor: AVAILABILITY_BG_COLOR.sold
  },
  {
    value: AVAILABILITY_STATUS.underContract,
    bgColor: AVAILABILITY_BG_COLOR.undercontract
  },
  {
    value: AVAILABILITY_STATUS.developerHeld,
    bgColor: AVAILABILITY_BG_COLOR.developerheld
  }
]

const TableTitle = ({ title, span = 2 }) => {
  return (
    <div
      className={
        'flex flex-1 bg-[#E3E3E1] border-softBlack30 border-b items-center justify-center border-l'
      }
    >
      <span className='text-softBlack70 font-medium text-xs uppercase'>
        {title}
      </span>
    </div>
  )
}

const UnitListView = ({
  appProject,
  userObject,
  units,
  gettingUnits,
  type,
  buildings = [],
  getBuildings = [],
  onSelect = () => {},
  classNames = null,
  showActionButtonOnHover = true,
  isAllocateInventory = false,
  isPublicPage = false,
  refetchUnits
}) => {
  // @ts-ignore
  const projectId = useSelector((state) => state.appReducer.appProject)
  useRealtimeUnitUpdate(projectId)
  const [data, setData] = useState({})
  const [building, setBuilding] = useState('')
  const [availabilityFilter, setAvailabilityFilter] = useState([])
  const [floorSortByAsc, setFloorSortByAsc] = useState(false)

  useEffect(() => {
    if (units.length > 0) {
      handleData()
    }
  }, [units, building, floorSortByAsc])

  const handleData = () => {
    let uCards = [...units]
    if (building.length > 0) {
      uCards = uCards.filter((_uCard) =>
        building.includes(_uCard?.building._id)
      )
    }
    const grouped = groupBy(uCards, (unit) => unit.floorNumber)
    // @ts-ignore
    const groupedKeyValuePair = {}
    grouped.forEach((value, key) => {
      return (groupedKeyValuePair[key] = value)
    })
    setData({ ...groupedKeyValuePair })
  }

  return (
    <div className={`${classNames ?? !isPublicPage ? 'mx-8 pb-4' : ''}`}>
      {type === 'inventoryUnit' && !isPublicPage && (
        <div className='flex flex-row justify-between content-center items-center my-8 h-11'>
          <div className='min-w-[322px]'>
            <SelectButtonWrapper>
              <SelectMultiple
                buttonLabel='Building'
                onChange={(newValue) => setBuilding(newValue)}
                options={buildings?.map((building) => ({
                  value: building?._id,
                  label: building?.name
                }))}
                multiple={false}
              />
            </SelectButtonWrapper>
          </div>
          <FilterRadioGroup
            options={filterOptions}
            currentValue={availabilityFilter}
            onValueChange={(newValue) => {
              setAvailabilityFilter(newValue)
            }}
          />
        </div>
      )}
      <div className='flex flex-col rounded border-[#BEBDBD] bg-[#FCFCFA] border'>
        <div className='flex flex-row w-full h-[42px] bg-[#E3E3E1]'>
          <button
            onClick={() => {
              setFloorSortByAsc(!floorSortByAsc)
            }}
            className='flex w-22 h-full border-softBlack30 border-b text-center items-center align-baseline justify-center text-softBlack70 font-medium text-xs uppercase'
          >
            <span>Floor</span>
            <span className='ml-1.5'>
              <svg
                width='13'
                height='12'
                viewBox='0 0 13 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M5.48484 8.73482L4.62502 9.59466V1.5C4.62502 1.40054 4.58552 1.30516 4.51519 1.23483C4.44486 1.16451 4.34948 1.125 4.25002 1.125C4.15057 1.125 4.05519 1.16451 3.98486 1.23483C3.91453 1.30516 3.87502 1.40054 3.87502 1.5V9.59466L3.01521 8.73482C2.94488 8.66449 2.84949 8.62497 2.75002 8.62497C2.65056 8.62497 2.55517 8.66449 2.48484 8.73482C2.41451 8.80515 2.375 8.90054 2.375 9C2.375 9.09946 2.41451 9.19485 2.48484 9.26518L3.98484 10.7652C3.98663 10.7669 3.98857 10.7684 3.99038 10.7702C3.99745 10.777 4.00462 10.7837 4.01222 10.7899C4.01704 10.7939 4.0221 10.7973 4.02709 10.801C4.03192 10.8046 4.03666 10.8084 4.04167 10.8118C4.04735 10.8156 4.05323 10.8189 4.05907 10.8223C4.06376 10.8251 4.06831 10.8281 4.07314 10.8306C4.07896 10.8338 4.08493 10.8364 4.09088 10.8392C4.09605 10.8416 4.10114 10.8442 4.10644 10.8464C4.11214 10.8488 4.11798 10.8507 4.12379 10.8528C4.12954 10.8548 4.13521 10.857 4.14107 10.8588C4.14686 10.8606 4.15275 10.8618 4.1586 10.8633C4.16462 10.8648 4.17058 10.8665 4.17671 10.8677C4.18337 10.869 4.1901 10.8698 4.19681 10.8708C4.20223 10.8716 4.20754 10.8726 4.21301 10.8731C4.2253 10.8743 4.23766 10.875 4.25002 10.875C4.26238 10.875 4.27474 10.8743 4.28703 10.8731C4.2925 10.8726 4.29781 10.8716 4.30324 10.8708C4.30994 10.8698 4.31667 10.869 4.32333 10.8677C4.32947 10.8665 4.33542 10.8648 4.34144 10.8633C4.3473 10.8618 4.35318 10.8606 4.35897 10.8588C4.36483 10.857 4.3705 10.8548 4.37625 10.8528C4.38206 10.8507 4.3879 10.8488 4.3936 10.8464C4.39891 10.8442 4.40399 10.8416 4.40916 10.8392C4.41511 10.8364 4.42108 10.8338 4.4269 10.8306C4.43173 10.8281 4.43628 10.8251 4.44097 10.8223C4.44681 10.8189 4.45269 10.8156 4.45837 10.8118C4.46338 10.8084 4.46812 10.8046 4.47295 10.801C4.47794 10.7973 4.48299 10.7939 4.48782 10.7899C4.49542 10.7837 4.50259 10.777 4.50966 10.7702C4.51147 10.7684 4.51341 10.7669 4.5152 10.7652L6.0152 9.26518C6.08553 9.19485 6.12504 9.09946 6.12504 9C6.12504 8.90054 6.08553 8.80515 6.0152 8.73482C5.94487 8.66449 5.84948 8.62497 5.75002 8.62497C5.65055 8.62497 5.55516 8.66449 5.48483 8.73482H5.48484Z'
                  fill='#2E2B2E'
                  fillOpacity='0.7'
                />
                <path
                  d='M10.5152 2.73476L9.0152 1.23476C9.01355 1.23314 9.01177 1.23176 9.0101 1.23016C9.00289 1.22322 8.99556 1.2164 8.98783 1.21004C8.98302 1.2061 8.97798 1.20265 8.97304 1.19899C8.96814 1.19535 8.96341 1.19157 8.95835 1.18818C8.95272 1.18441 8.9469 1.18116 8.94114 1.17772C8.93638 1.17491 8.93175 1.17191 8.92688 1.1693C8.92113 1.16621 8.91523 1.1636 8.90935 1.16085C8.9041 1.15838 8.89893 1.15575 8.89355 1.15353C8.88792 1.1512 8.88218 1.14932 8.87646 1.14728C8.87064 1.14518 8.86487 1.14293 8.85892 1.14112C8.8532 1.13941 8.84741 1.13812 8.84162 1.13668C8.83553 1.13515 8.82951 1.13343 8.82331 1.13222C8.81672 1.13089 8.81004 1.13012 8.80337 1.12918C8.79793 1.1284 8.79255 1.12735 8.78703 1.12682C8.76242 1.12439 8.73763 1.12439 8.71301 1.12682C8.7075 1.12735 8.70212 1.1284 8.69667 1.12918C8.69001 1.13011 8.68333 1.13089 8.67673 1.13222C8.67053 1.13343 8.66451 1.13515 8.65842 1.13668C8.65263 1.13813 8.64684 1.13941 8.64112 1.14112C8.63517 1.14293 8.6294 1.14518 8.62359 1.14728C8.61787 1.14932 8.61212 1.1512 8.60649 1.15353C8.60111 1.15575 8.59594 1.15838 8.5907 1.16085C8.58482 1.1636 8.57891 1.16621 8.57317 1.1693C8.56829 1.17191 8.56367 1.17491 8.55891 1.17772C8.55314 1.18116 8.54733 1.18441 8.5417 1.18818C8.53664 1.19157 8.5319 1.19535 8.527 1.19899C8.52206 1.20265 8.51702 1.2061 8.51222 1.21004C8.50448 1.2164 8.49716 1.22322 8.48995 1.23016C8.48828 1.23176 8.48649 1.23314 8.48484 1.23476L6.98484 2.73476C6.95002 2.76958 6.92239 2.81093 6.90355 2.85643C6.8847 2.90193 6.875 2.95069 6.875 2.99994C6.875 3.04919 6.8847 3.09796 6.90355 3.14346C6.92239 3.18896 6.95002 3.2303 6.98484 3.26513C7.05517 3.33546 7.15056 3.37497 7.25003 3.37497C7.29927 3.37497 7.34804 3.36527 7.39354 3.34642C7.43904 3.32757 7.48038 3.29995 7.51521 3.26513L8.37502 2.40529V10.4999C8.37502 10.5994 8.41453 10.6948 8.48485 10.7651C8.55518 10.8354 8.65056 10.8749 8.75002 10.8749C8.84948 10.8749 8.94486 10.8354 9.01519 10.7651C9.08551 10.6948 9.12502 10.5994 9.12502 10.4999V2.40529L9.98484 3.26513C10.0197 3.29995 10.061 3.32758 10.1065 3.34642C10.152 3.36527 10.2008 3.37497 10.25 3.37497C10.2993 3.37497 10.348 3.36527 10.3935 3.34642C10.439 3.32758 10.4804 3.29995 10.5152 3.26513C10.55 3.2303 10.5777 3.18896 10.5965 3.14346C10.6153 3.09796 10.625 3.04919 10.625 2.99994C10.625 2.9507 10.6153 2.90193 10.5965 2.85643C10.5777 2.81093 10.55 2.76959 10.5152 2.73476V2.73476Z'
                  fill='#2E2B2E'
                  fillOpacity='0.7'
                />
              </svg>
            </span>
          </button>
          <div className='flex-1 flex flex-row w-full h-full border-softBlack'>
            <TableTitle title='north' />
            <TableTitle title='east' />
            <TableTitle title='south' />
            <TableTitle title='west' />
          </div>
        </div>
        {gettingUnits && (
          <div className='px-2'>
            <Skeleton height={59} />
            <Skeleton height={59} />
            <Skeleton height={59} />
          </div>
        )}
        {!gettingUnits && Object.keys(data).length === 0 && (
          <div className='text-center font-bold text-2xl pt-2'>No Result</div>
        )}
        <div className='space-y-2 mt-2'>
          {Object.keys(data).length > 0 &&
            Object.keys(data)
              .sort((a, b) => {
                // @ts-ignore
                return floorSortByAsc ? a - b : b - a
              })
              .map((key) => {
                return (
                  <FloorItem
                    key={key}
                    data={data[key]}
                    floorNUmber={parseInt(key)}
                    availabilityFilter={availabilityFilter}
                    type={type}
                    onSelect={onSelect}
                    showActionButtonOnHover={showActionButtonOnHover}
                    isAllocateInventory={isAllocateInventory}
                    isPublicPage={isPublicPage}
                    refetchUnits={refetchUnits}
                  />
                )
              })}
        </div>
      </div>
    </div>
  )
}

export default UnitListView
